import { AppBar } from "@material-ui/core";
import React from "react";
import { PersonDetails } from "./PersonDetails";

export function ChatHeader(props) {
  const { chatTemplate, currentChat } = props;
  const { header } = chatTemplate;
  return (
    <AppBar
      position="static"
      style={{
        width: "100%",
        background: header.background,
        boxShadow: "none",
        maxHeight: 76,
        borderBottom: `1px solid ${header.borderColor}`,
      }}
    >
      <PersonDetails {...props} />
    </AppBar>
  );
}
